import { Box } from "@mui/material";
import NextLink from "next/link";
import Kicker from "@/src/components/common/broadsheet/kicker";
import {
  FONT_UI,
  hairlineTop,
} from "@/src/components/common/broadsheet/tokens";

const Keywords = ({
  journalPath,
  isMainSite = false,
  keywords = [],
}: {
  journalPath?: string;
  isMainSite?: boolean;
  keywords?: string[];
}) => {
  const base = isMainSite || !journalPath ? "" : `/journals/${journalPath}`;
  const SEARCH_URL = `${base}/search?search_term=`;
  const present = keywords.filter((keyword) => keyword && keyword.trim());

  if (present.length === 0) return null;

  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        gap: 0.375,
        mt: 1.25,
        pt: 0.75,
        ...hairlineTop,
      }}
    >
      <Kicker component="span" sx={{ mr: 0.25 }}>
        Keywords
      </Kicker>
      {present.map((keyword, index) => (
        <Box
          key={`keyword-${index}`}
          component={NextLink}
          href={`${SEARCH_URL}${encodeURIComponent(keyword.trim())}&search_parts=keywords`}
          sx={{
            fontFamily: FONT_UI,
            fontSize: "0.75rem",
            lineHeight: 1.4,
            color: "custom.link",
            textDecoration: "none",
            border: "1px solid",
            borderColor: "custom.ruleHairline",
            borderRadius: 0,
            px: 0.625,
            py: 0.3125,
            "&:hover": {
              borderColor: "custom.link",
              backgroundColor: "custom.newsprintRaised",
            },
          }}
        >
          {keyword.trim()}
        </Box>
      ))}
    </Box>
  );
};

export default Keywords;
